/* Pulse Performance — quick add-to-cart with inline quantity stepper
 * Used by pulse-variant-card and pulse-spotlight. Relies on Dawn globals:
 *   window.routes.cart_add_url / cart_change_url / cart_url
 *   publish() + PUB_SUB_EVENTS.cartUpdate  (pubsub.js / constants.js)
 */
(function () {
  'use strict';

  // ── Helpers ─────────────────────────────────────────────────────

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  function patchCartBubble(sections) {
    var el = document.getElementById('cart-icon-bubble');
    if (!el || !sections || !sections['cart-icon-bubble']) return;
    var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var node = doc.querySelector('.shopify-section');
    if (node) el.innerHTML = node.innerHTML;
  }

  function notifyDawn(cartData) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pulse-quick-add', cartData: cartData });
    }
  }

  // ── UI state ─────────────────────────────────────────────────────

  // Falls back to `atc` itself when there is no .ppt-card ancestor — allows
  // the spotlight carousel (which has no card wrapper) to toggle is-in-cart
  // on the .ppt-atc element directly, which its own CSS uses for visibility.
  function showStepper(atc, qty, lineKey) {
    var card  = atc.closest('.ppt-card') || atc;
    var qtyEl = atc.querySelector('.ppt-stepper__qty');
    card.classList.add('is-in-cart');
    if (qtyEl) qtyEl.textContent = qty;
    if (lineKey) atc.dataset.lineKey = lineKey;
  }

  function showButton(atc) {
    var card = atc.closest('.ppt-card') || atc;
    var btn  = atc.querySelector('.ppt-btn--add');
    card.classList.remove('is-in-cart');
    if (btn) btn.disabled = false;
    delete atc.dataset.lineKey;
  }

  // ── Cart actions ─────────────────────────────────────────────────

  function handleAdd(atc) {
    var btn    = atc.querySelector('.ppt-btn--add');
    var _addVid = parseInt(atc.dataset.variantId, 10);
    if (btn) btn.disabled = true;

    postJson(window.routes.cart_add_url, {
      id: _addVid,
      quantity: 1,
      sections: ['cart-icon-bubble'],
      sections_url: window.location.pathname,
    }).then(function (data) {
      if (data.status) {          // Shopify error (e.g. out of stock)
        if (btn) btn.disabled = false;
        var soldOut = atc.querySelector('.pps-sold-out');
        if (soldOut) soldOut.textContent = 'Vyprodáno';
        return;
      }
      showStepper(atc, 1, data.key);
      // Update cart items cache so spotlight slide-switch syncs correctly
      var _items = window._ppsCartItems || [];
      var _found = false;
      for (var _i = 0; _i < _items.length; _i++) {
        if (_items[_i].variant_id === _addVid) {
          _items[_i].quantity = 1; _items[_i].key = data.key; _found = true; break;
        }
      }
      if (!_found) _items.push({ variant_id: _addVid, quantity: 1, key: data.key });
      window._ppsCartItems = _items;
      patchCartBubble(data.sections);
      notifyDawn(data);
    }).catch(function () {
      if (btn) btn.disabled = false;
    });
  }

  function handleChange(atc, delta) {
    if (atc.dataset.pending) return;        // debounce concurrent taps
    var qtyEl   = atc.querySelector('.ppt-stepper__qty');
    var current = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
    var next    = current + delta;

    if (next <= 0) {
      handleRemove(atc);
      return;
    }

    // Optimistic update
    if (qtyEl) qtyEl.textContent = next;
    atc.dataset.pending = '1';

    postJson(window.routes.cart_change_url, {
      id: atc.dataset.lineKey,
      quantity: next,
      sections: ['cart-icon-bubble'],
      sections_url: window.location.pathname,
    }).then(function (data) {
      delete atc.dataset.pending;
      if (data.errors || data.status) {
        if (qtyEl) qtyEl.textContent = current;   // revert on error
        return;
      }
      if (data.items) window._ppsCartItems = data.items;
      patchCartBubble(data.sections);
      notifyDawn(data);
    }).catch(function () {
      delete atc.dataset.pending;
      if (qtyEl) qtyEl.textContent = current;
    });
  }

  function handleRemove(atc) {
    var lineKey = atc.dataset.lineKey;      // grab before showButton clears it
    showButton(atc);                        // optimistic revert
    if (!lineKey) return;

    postJson(window.routes.cart_change_url, {
      id: lineKey,
      quantity: 0,
      sections: ['cart-icon-bubble'],
      sections_url: window.location.pathname,
    }).then(function (data) {
      if (data.items) window._ppsCartItems = data.items;
      patchCartBubble(data.sections);
      notifyDawn(data);
    }).catch(function () { /* button already reverted */ });
  }

  // ── Event delegation ─────────────────────────────────────────────

  document.addEventListener('click', function (e) {
    var atc = e.target.closest('.ppt-atc[data-variant-id]');
    if (!atc) return;

    if (e.target.closest('.ppt-btn--add')) {
      e.preventDefault();
      handleAdd(atc);
    } else if (e.target.closest('.ppt-stepper__dec')) {
      e.preventDefault();
      handleChange(atc, -1);
    } else if (e.target.closest('.ppt-stepper__inc')) {
      e.preventDefault();
      handleChange(atc, +1);
    }
  });

  // ── On-load: reflect existing cart state ─────────────────────────

  function initFromCart() {
    fetch(window.routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        window._ppsCartItems = items;    // cache for spotlight slide-switch sync
        if (!items.length) return;

        document.querySelectorAll('.ppt-atc[data-variant-id]').forEach(function (atc) {
          var vid  = parseInt(atc.dataset.variantId, 10);
          var item = null;
          for (var i = 0; i < items.length; i++) {
            if (items[i].variant_id === vid) { item = items[i]; break; }
          }
          if (item) showStepper(atc, item.quantity, item.key);
        });
      })
      .catch(function () { /* non-critical, cards just show buy button */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFromCart);
  } else {
    initFromCart();
  }
})();
